import React, { forwardRef } from 'react';

const DownloadSamplesIcon = forwardRef((props, ref) => {
  const {
    style: { color },
    ...otherProps
  } = props;

  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      {...otherProps}
    >
      <g clipPath="url(#clip0_23496_2909)">
        <path
          d="M6.58552 12.0813C6.77126 12.2672 6.99179 12.4146 7.23453 12.5152C7.47726 12.6158 7.73744 12.6676 8.00019 12.6676C8.26294 12.6676 8.52312 12.6158 8.76585 12.5152C9.00859 12.4146 9.22912 12.2672 9.41486 12.0813L11.5555 9.94067C11.6703 9.81373 11.7319 9.64752 11.7275 9.47644C11.7231 9.30536 11.6531 9.14253 11.5319 9.02165C11.4108 8.90077 11.2478 8.8311 11.0767 8.82707C10.9056 8.82304 10.7396 8.88496 10.6129 9L8.66219 10.9513L8.66686 0.666667C8.66686 0.489856 8.59662 0.320286 8.4716 0.195262C8.34657 0.0702379 8.177 0 8.00019 0V0C7.82338 0 7.65381 0.0702379 7.52879 0.195262C7.40376 0.320286 7.33352 0.489856 7.33352 0.666667L7.32752 10.9387L5.38752 9C5.26243 8.875 5.0928 8.8048 4.91596 8.80486C4.73911 8.80493 4.56953 8.87524 4.44452 9.00033C4.31952 9.12543 4.24933 9.29506 4.24939 9.4719C4.24945 9.64875 4.31976 9.81833 4.44486 9.94333L6.58552 12.0813Z"
          fill={color}
        />
        <path
          d="M15.3333 10.6666C15.1565 10.6666 14.987 10.7368 14.8619 10.8618C14.7369 10.9869 14.6667 11.1564 14.6667 11.3332V13.9999C14.6667 14.1767 14.5964 14.3463 14.4714 14.4713C14.3464 14.5963 14.1768 14.6666 14 14.6666H2C1.82319 14.6666 1.65362 14.5963 1.5286 14.4713C1.40357 14.3463 1.33333 14.1767 1.33333 13.9999V11.3332C1.33333 11.1564 1.2631 10.9869 1.13807 10.8618C1.01305 10.7368 0.843478 10.6666 0.666667 10.6666C0.489856 10.6666 0.320286 10.7368 0.195262 10.8618C0.0702379 10.9869 0 11.1564 0 11.3332L0 13.9999C0 14.5303 0.210714 15.039 0.585786 15.4141C0.960859 15.7892 1.46957 15.9999 2 15.9999H14C14.5304 15.9999 15.0391 15.7892 15.4142 15.4141C15.7893 15.039 16 14.5303 16 13.9999V11.3332C16 11.1564 15.9298 10.9869 15.8047 10.8618C15.6797 10.7368 15.5101 10.6666 15.3333 10.6666Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_23496_2909">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
});

DownloadSamplesIcon.defaultProps = {
  style: {
    color: 'black',
  },
};

export default DownloadSamplesIcon;
